import { api } from './client'

export interface UserProfile {
  id: string
  username: string
  visibility: number
  follow_request_policy: string
  storage_tier: string | null
  created_at: string | null
  follow_status: 'following' | 'pending' | 'not_following' | null
  email?: string
  email_verified?: boolean
  is_sudo?: boolean
}

export interface ThemeColors {
  bg: string
  fg: string
  color1: string
  color2: string
}

export interface UserSettings {
  visibility: number
  follow_request_policy: string
  default_entry_privacy: number
  default_reply_privacy: number
  default_upload_privacy: number
  default_tagset_privacy: number
  feed_include_own: boolean
  feed_include_friends: boolean
  feed_include_fof: boolean
  feed_include_randos: boolean
  color_theme: ThemeColors | null
  default_scheme_id: string | null
  notify_follow_requests_email: boolean
}

export interface UserSettingsUpdate {
  follow_request_policy?: string
  visibility?: number
  default_entry_privacy?: number
  default_reply_privacy?: number
  default_upload_privacy?: number
  default_tagset_privacy?: number
  feed_include_own?: boolean
  feed_include_friends?: boolean
  feed_include_fof?: boolean
  feed_include_randos?: boolean
  color_theme?: ThemeColors | null
  default_scheme_id?: string | null
  notify_follow_requests_email?: boolean
}

export interface FollowRequest {
  id: string
  requester_id: string
  requester_username: string
  created_at: string
}

export function getUserProfile(username: string): Promise<UserProfile> {
  return api.get<UserProfile>(`/users/${username}/profile`)
}

export function getUserSettings(username: string): Promise<UserSettings> {
  return api.get<UserSettings>(`/users/${username}/settings`)
}

export function updateUserSettings(username: string, settings: UserSettingsUpdate): Promise<UserSettings> {
  return api.patch<UserSettings>(`/users/${username}/settings`, settings)
}

export function followUser(username: string): Promise<{ status: string }> {
  return api.post<{ status: string }>(`/users/${username}/follow`, {})
}

export function unfollowUser(username: string): Promise<void> {
  return api.delete(`/users/${username}/follow`)
}

export function getFollowRequests(username: string): Promise<FollowRequest[]> {
  return api.get<FollowRequest[]>(`/users/${username}/follow-requests`)
}

export function handleFollowRequest(username: string, reqId: string, action: 'approve' | 'reject'): Promise<{ status: string }> {
  return api.post<{ status: string }>(`/users/${username}/follow-requests/${reqId}`, { action })
}

export function updateIdentity(username: string, fields: { bio_entry_id?: string; avatar_entry_id?: string }): Promise<{ bio_entry_id: string | null; avatar_entry_id: string | null }> {
  return api.put(`/users/${username}/identity`, fields)
}

export function listFollowing(username: string): Promise<string[]> {
  return api.get<string[]>(`/users/${username}/following`)
}
